// extracted by mini-css-extract-plugin
module.exports = {"cancelContentPaddingX":"style_cancelContentPaddingX__K7ZAG"};